import { Colors } from '../../colors';
import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const MailLine = ({ width = 18, height = 18, fill = Colors.gray700, ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill={fill}
        d="M3.23081 14.625C2.85194 14.625 2.53125 14.4938 2.26875 14.2313C2.00625 13.9688 1.875 13.6481 1.875 13.2692V4.73081C1.875 4.35194 2.00625 4.03125 2.26875 3.76875C2.53125 3.50625 2.85194 3.375 3.23081 3.375H14.7692C15.1481 3.375 15.4688 3.50625 15.7313 3.76875C15.9938 4.03125 16.125 4.35194 16.125 4.73081V13.2692C16.125 13.6481 15.9938 13.9688 15.7313 14.2313C15.4688 14.4938 15.1481 14.625 14.7692 14.625H3.23081ZM9 9.41831L3 5.58169V13.2692C3 13.3366 3.02163 13.3919 3.06488 13.4351C3.10813 13.4784 3.16344 13.5 3.23081 13.5H14.7692C14.8366 13.5 14.8919 13.4784 14.9351 13.4351C14.9784 13.3919 15 13.3366 15 13.2692V5.58169L9 9.41831ZM9 8.25L14.8847 4.5H3.11531L9 8.25ZM3 5.58169V4.5V13.2692C3 13.3366 3.02163 13.3919 3.06488 13.4351C3.10813 13.4784 3.16344 13.5 3.23081 13.5H3V5.58169Z"
      />
    </Svg>
  );
};

export default MailLine;
